module.exports = __webpack_public_path__ + "img/img_blank2.960693e2.png";